<template>
  <v-container class="mt-4" style="max-width: 900px;">
    <v-alert
      v-if="companyViewEnabled"
      type="info"
      color="#1E3A5F"
      dark
      prominent
      class="mb-6"
      rounded="lg"
    >
      <div class="d-flex align-center">
        <v-icon large class="mr-3">mdi-domain</v-icon>
        <div>
          <div class="text-subtitle-1 font-weight-medium">Your organization includes Plus features</div>
          <div class="text-body-2">All premium features are available through your enterprise license — no upgrade needed.</div>
        </div>
      </div>
    </v-alert>

    <div class="text-center mb-6">
      <h1
        class="text-h4 font-weight-bold"
        :style="{ color: $vuetify.theme.dark ? '#9FB8D6' : '#1E3A5F' }"
      >
        Unlock Your Full Career Toolkit
      </h1>
      <p class="text-subtitle-1 text--secondary mt-2">Resumation Plus — $5/month</p>
    </div>

    <v-row>
      <v-col cols="12" md="6">
        <v-card outlined rounded="lg" height="100%">
          <v-card-title class="grey lighten-4 py-3">
            <div class="text-center" style="width: 100%;">
              <div class="text-h6 font-weight-medium" style="color: #1E3A5F;">Free</div>
              <div class="text-body-2" style="color: #5b6270;">Get started at no cost</div>
            </div>
          </v-card-title>
          <v-card-text class="pa-5">
            <div
              v-for="feature in freeFeatures"
              :key="feature"
              class="d-flex align-start mb-3"
            >
              <v-icon small color="success" class="mr-2 mt-1">mdi-check</v-icon>
              <span class="text-body-2">{{ feature }}</span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card rounded="lg" elevation="4" height="100%" style="border: 2px solid #007AFF;">
          <v-card-title class="py-3" style="background-color: #007AFF; color: white;">
            <div class="text-center" style="width: 100%;">
              <v-icon small class="mr-1" color="white">mdi-star</v-icon>
              <span class="text-h6 font-weight-medium">Plus</span>
              <div class="text-body-2" style="opacity: 0.9;">$5/month</div>
            </div>
          </v-card-title>
          <v-card-text class="pa-5">
            <div
              class="text-body-2 font-weight-medium mb-3"
              :style="{ color: $vuetify.theme.dark ? '#9FB8D6' : '#1E3A5F' }"
            >
              Everything in Free, plus:
            </div>
            <div
              v-for="feature in plusFeatures"
              :key="feature"
              class="d-flex align-start mb-3"
            >
              <v-icon small color="#007AFF" class="mr-2 mt-1">mdi-check-circle</v-icon>
              <span class="text-body-2">{{ feature }}</span>
            </div>
          </v-card-text>
          <v-card-actions v-if="!companyViewEnabled" class="pa-5 pt-0">
            <v-btn
              color="primary"
              block
              large
              @click="redirectToCheckout()"
            >
              <v-icon left>mdi-star</v-icon>
              Upgrade to Plus — $5/month
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Upgrade",
  data: () => ({
    freeFeatures: [
      "Career Profile — build and maintain your record",
      "Small Wins — capture achievements manually",
      "Fit & Preferences — set your career goals",
      "Resume Download — all standard formats",
      "Profile Export — full career dossier",
      "AI Resume Upload — extract from existing resume",
    ],
    plusFeatures: [
      "Sage AI Coach — unlimited conversations, all modes",
      "Career Story Generator — LinkedIn headline, bio, stories",
      "Cover Letter Generator — tailored to any role",
      "Job Fit Analyzer — match against any job description",
      "Career Pathway Analyzer — explore career directions",
      "AI Resume Optimization — enhance your content with AI",
      "Multiple Saved Resumes — store and manage versions",
      "Period Summary — AI-generated review-ready narratives",
    ],
  }),
  computed: {
    ...mapState("settings", ["companyViewEnabled"]),
  },
  methods: {
    redirectToCheckout() {
      window.location.href = "/api/PaymentGateway";
    },
  },
};
</script>
